// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SketchOutlinedSvg from "@ant-design/icons-svg/es/asn/SketchOutlined";
import AntdIcon from '../components/AntdIcon';

var SketchOutlined = function SketchOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SketchOutlinedSvg
  }));
};

SketchOutlined.displayName = 'SketchOutlined';
export default React.forwardRef(SketchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SketchOutlined.js
// module id = 1807
// module chunks = 0